export const labelPrinterDeviceReducer = (state = null, action) => {
  switch (action.type) {
    case 'SET_LABEL_PRINTER_DEVICE':
      return action.payload;
    default:
      return state;
  }
};
